/**
 * 공통 변수 mixin
 *
 * @since 2021-06-04
 * @author wj_tams_dev04
 */
export default {
  data () {
    return {
      // 사용여부
      usedOptions: [
        { value: 1, label: this.$t('cmn.used') },
        { value: 0, label: this.$t('cmn.unUsed') }
      ]
    }
  },
  computed: {
    // IP Type 설정(ip_type): all(0), ipv4(1), ipv6(2)
    ipTypeList () {
      return [
        {
          icon: 'bs-q-btn-flat-ico-iptype-all',
          ipType: 0,
          label: 'IPv4 + IPv6',
          value: 'v46'
        },
        {
          icon: 'bs-q-btn-flat-ico-iptype-v4',
          ipType: 1,
          label: 'IPv4',
          value: 'v4'
        },
        {
          icon: 'bs-q-btn-flat-ico-iptype-v6',
          ipType: 2,
          label: 'IPv6',
          value: 'v6'
        }
      ]
    },
    // 지원 장비 타입(20: NGF, 21: IPS, 23: ADS), default: 빈 배열(TAMS)
    deviceTypeList () {
      return [
        { value: 20, label: 'NGF', css: 'type-ngf', style: 'margin-right: 2px;' },
        { value: 21, label: 'IPS', css: 'type-ips', style: 'margin-right: 2px;' },
        { value: 23, label: 'ADS', css: 'type-ads', style: '' }
      ]
    }
  }
}
